import React from 'react';
import prettyBytes from 'pretty-bytes';

const PrettyBytes = ({ bytes, option }) => (
  <div>{prettyBytes(bytes, option)}</div>
);

export default PrettyBytes;
